import { render, staticRenderFns } from "./TinyMCE.vue?vue&type=template&id=8f1ed298&"
import script from "./TinyMCE.vue?vue&type=script&lang=ts&"
export * from "./TinyMCE.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports